'use es6';

export const DETRACTOR = 'DETRACTOR';
export const PASSIVE = 'PASSIVE';
export const PROMOTER = 'PROMOTER';